import script from "./Variant.vue?vue&type=script&setup=true&lang=js"
export * from "./Variant.vue?vue&type=script&setup=true&lang=js"

import "./Variant.vue?vue&type=style&index=0&id=8b0f57a0&lang=scss"

const __exports__ = script;

export default __exports__